var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.416 10.8327H10.8327V15.416C10.8327 15.6461 10.6461 15.8327 10.416 15.8327H9.58268C9.35256 15.8327 9.16602 15.6461 9.16602 15.416V10.8327H4.58268C4.35256 10.8327 4.16602 10.6461 4.16602 10.416V9.58268C4.16602 9.35256 4.35256 9.16602 4.58268 9.16602H9.16602V4.58268C9.16602 4.35256 9.35256 4.16602 9.58268 4.16602H10.416C10.6461 4.16602 10.8327 4.35256 10.8327 4.58268V9.16602H15.416C15.6461 9.16602 15.8327 9.35256 15.8327 9.58268V10.416C15.8327 10.6461 15.6461 10.8327 15.416 10.8327Z",
    fill: "#567AE8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.fcec609c.svg";
export { ForwardRef as ReactComponent };